// internal
import React from "react";

//dep
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Checkbox, CHECKBOX_ACCENT } from "@swiggy-private/core-ui";
import { CUTLERY_WIDGET_DATA_TEST_ID } from "@swiggy-private/cart-test-ids";

// styles
import { CutleryOptInOut, CutleryLabel } from "./styles";

// constants
import { SEND_CUTLERY_TEXT } from "./constants";

export interface CutleryOptInOutWidgetProps {
    checked: boolean;
    onCutleryOptChange: VoidFunction;
    cutleryRef: React.RefObject<HTMLDivElement>;
    title?: string;
}

const CutleryOptInOutWidget: React.FC<CutleryOptInOutWidgetProps> = ({
    checked = false,
    onCutleryOptChange,
    cutleryRef,
    title,
}) => {
    const CHECKBOX_NAME = "cutlery-opt-in-out";
    const labelText = title ?? SEND_CUTLERY_TEXT;

    return (
        <CutleryOptInOut
            ref={cutleryRef}
            data-testid={CUTLERY_WIDGET_DATA_TEST_ID.CONTAINER}
            onClick={onCutleryOptChange}
            tabIndex={0}
            role="button"
        >
            <Checkbox
                checked={checked}
                name="cutlery-opt-in-out"
                accent={CHECKBOX_ACCENT.SWIGGY_ORANGE}
                isLightBorder
                attrs={{ id: CHECKBOX_NAME }}
            />
            <CutleryLabel htmlFor={CHECKBOX_NAME}>
                <Text as="span" variant="V2.body3.neutral.medium" color="text_Med_Emphasis">
                    {labelText}
                </Text>
            </CutleryLabel>
        </CutleryOptInOut>
    );
};

export default React.memo(CutleryOptInOutWidget);
